import { api } from '@/services/api'
import { useAuthStore } from '@/stores/authStore'
import type { CurrentUser, TokenResponse } from '@/types/api'

export interface StudentCredentials {
  matricula: string
  password: string
  school_id: string
  tenant_slug?: string
}

export async function login(credentials: StudentCredentials): Promise<TokenResponse> {
  const { data } = await api.post<TokenResponse>('/auth/login', credentials)
  useAuthStore.getState().setTokens(data.access_token, data.refresh_token)
  return data
}

export async function me(): Promise<CurrentUser> {
  const { data } = await api.get<CurrentUser>('/auth/me')
  useAuthStore.getState().setUser(data)
  return data
}

export async function changePassword(current: string, next: string): Promise<void> {
  await api.post('/auth/change-password', {
    current_password: current,
    new_password: next,
  })
}

/** Sai da sessão. NUNCA rejeita — e isso é decisão, não descuido.
 *
 * A revogação no servidor é *best-effort*: o que importa para quem está na
 * frente do computador é a sessão local sumir, e isso acontece sempre, no
 * `finally`. Não há nada de útil que o chamador possa fazer com "o servidor não
 * confirmou a saída", e deixar a promessa rejeitar produzia *unhandled
 * rejection* a cada logout sem rede — que num Chromebook de escola é rotina, e
 * não exceção.
 */
export async function logout(): Promise<void> {
  const { refreshToken, clear } = useAuthStore.getState()
  try {
    if (refreshToken) {
      await api.post('/auth/logout', { refresh_token: refreshToken })
    }
  } catch {
    /* o token expira sozinho no servidor; a sessão local já vai embora abaixo */
  } finally {
    clear()
  }
}
